import React, { useState } from 'react';
import { fetchArticles } from '../../api/endpoints'
import { useQuery } from '@tanstack/react-query'
import { Card, Col, Row } from 'react-bootstrap'
import Spinner from 'react-bootstrap/Spinner';
import Allblog from './AllBlog'


const Blog = () => {
    const [currentPage] = useState(1);
    const [limit] = useState(20);
    const { isLoading, isError, data, error } = useQuery({
        queryKey: ['blog-page', currentPage],
        queryFn: async () => {
            return await fetchArticles(limit, currentPage)
        },
    })

    if (isLoading) {
        return <div className="d-flex flex-column justify-content-center justify-content-center align-items-center" style={{ height: "50vh" }}>
            <Spinner animation="border" role="status" style={{ height: "89px", width: "89px" }}>
                <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-3">Kindly be patient while we fetch your data</p>
        </div>
    }

    if (isError) {
        return (
            <p>An Error Occurred : {error.message}</p>
        )
    }

    const articles = data?.data ?? [];
    return (
        <div className="blog-container">

            <Row>
                <Col xl={12} lg={12}>
                    <Card>
                        <Card.Body>
                            <h4 className="meet-title light img-han">Recent Blog Post</h4>
                            {articles?.map((bok, i) => <Allblog bok={bok} key={i} />)}

                        </Card.Body>
                    </Card>
                </Col>

            </Row>

            <Col md={12}>

            </Col>


        </div>

    )
}
export default Blog;
